module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Prologue.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-12"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("Prologue")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "lic",
    staticStyle: {
      "font-size": "1.76em"
    },
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("T")]), _vm._v("he sound of her laughter filled his head as well as his heart, echoing all through him. Generating within him, as it always did, a feeling of tremendous joy and well-being.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It was one of those absolutely perfect Montana mornings that begged to be pressed between the pages of his memory. Cody Overton tried to absorb it as much as possible, instinctively knowing that it was important he do so.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Very important.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He and Renee were at the state fair—Renee always loved the state fair—and, as always, the love of his life had coaxed him onto one of the gaily-painted horses on the weathered carousel while she had mounted the one right next to it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Tame stuff,” Cody had pretended to grumble before they got on—as if he ever could have denied Renee anything. “At least let’s ride the Ferris wheel instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But Renee paid no attention to his protest. His wife absolutely "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("loved")]), _vm._v(" riding the carousel; she always had, even when they’d been in elementary school together. He’d teased her that he was surprised she hadn’t insisted on their taking their wedding vows sitting astride two of the horses on the carousel.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Renee had laughed and said that they would have had to wait for the state fair to come through and she hadn’t wanted to delay becoming Mrs. Cody Overton a moment longer than she had to.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She had always had a sense of urgency about living life to the fullest. It never made any sense to him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Until, sadly, it did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Maybe, if we close our eyes and wish real hard, the carousel’ll go faster. C’mon, Cody, give it a try. Close your eyes and wish,” she’d entreated, wrapping her hands around the horse’s pole before her. She was like a ray of sunshine. “Don’t you believe in wishes?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not anymore.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The words seemed to silently resonant in his head even as the carousel began to speed up, spinning faster and faster. Just as she’d wished it would.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And as the speed increased, so did the sound of her laughter, until that was all there was, just her laughter overpowering everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And all the while, they were spinning ever faster and faster.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cody kept trying to see her, to fix his eyes only on his beautiful Renee, but suddenly, he couldn’t find her, couldn’t see her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Couldn’t see anything at all except a sea of smeared color bleeding into itself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Twenty-five years old and she was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His soul realized it before his mind did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He began calling out her name, but nothing came out of his mouth except for an anguished, guttural cry.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With a start, Cody bolted upright in his bed. As always, when this dream came to him, he was covered in sweat and shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The crisp September weather had slipped into the bedroom, thanks to a window he’d forgotten to close, but he was still sweating.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still shaking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Still praying it really wasn’t just a dream. That Renee was still alive and with him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nurturing a hope that was completely foreign to his very practical, pessimistic outlook, Cody slowly looked to his left, to the spot beside him that had once belonged to Renee.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Aching so badly to see her that it physically hurt. But he didn’t see her. She wasn’t there, as he knew she wouldn’t be.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She hadn’t been there for eight years.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Hadn’t been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anywhere")]), _vm._v(" for eight years because she’d been dead for eight years. Another statistic to the ravages of the insatiable cancer monster.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His heart had been dead just as long.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At times, Cody was surprised that it was still beating, still keeping the shell that surrounded it alive and moving.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A man with nothing to live for shouldn’t be required to live,")]), _vm._v(" Cody thought darkly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He tossed off the covers and got out of bed despite the darkness that still enveloped the room. He knew it was useless to try to go back to sleep. Sleep was gone for the remainder of the night. If he was lucky, a glimmer of it might return by that evening.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Most likely not.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Slipping on the discarded jeans he picked up from the floor, Cody padded across the bare floor to the window and looked out.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("There was nothing to see, just a vastness that spread out before him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Their")]), _vm._v(" ranch.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why did you leave me?” he demanded in angry frustration, not for the first time. “Why did you have to go?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wasn’t being reasonable, but he didn’t much feel like being reasonable. It wasn’t fair that he had been left behind, to face each day without Renee after she had filled so much of his life before then. He couldn’t remember a time when he hadn’t known her, hadn’t been aware of her. The very first memory he had was of her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Eight years and he still wasn’t used to it. Hadn’t made his peace with it. Eight years and a part of him still expected to see her walk through the door, or see her standing over the stove, lamenting that she’d burned dinner—again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d never minded those burnt offerings—that was what he’d teasingly called them, her burnt offerings—and he would have been willing to eat nothing else for the rest of his life if only he could see her one more time. Hold her one more time...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He supposed, in a way, that was what the dreams were about. Seeing her one more time. Because they were so very vivid that, just for a moment, Renee was alive again. Alive and the cornerstone of his world.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He wished he could sleep forever, but that wasn’t going to happen.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Cody dragged his hand through his hair and sighed. He might as well get dressed and get started with his day, even if it was still the middle of the night. The ranch wasn’t going to run itself.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I miss you, Renee.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His whisper echoed about the empty bedroom just as it did about his empty soul.")]), _vm._v(" "), _c('p', {
    staticClass: "No-Paragraph-Style-11"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-143cd8bd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 81
// module chunks = 0